// import React from 'react'
// import cer1 from './image/cer1.jpeg'
// import cer2 from './image/cer2.jpg'
// import cer3 from './image/cer3.jpg'

// function Certificates() {
//     const certificates = [
//         { src: cer1, alt: 'Certificate 1' },
//         { src: cer2, alt: 'Certificate 2' },
//         { src: cer3, alt: 'Certificate 3' },
//       ];
//   return (
//     <div>
//       <div className='container py-4'>
//         <div className='row'>
//           <div className='col-md-1'></div>
//           <div className='col-md-10'>
//             <div className='text-center Certificates_text'>
//               <h2 className='display-5 pb-2'>Certificates</h2>
//               <p className=''>Prove Your Knowledge with Our Highly Esteemed Certifications, valued in All Professions.</p>
//             </div>
//           </div>
//           <div className='col-md-1'></div>
//         </div>
//         <div className='d-none d-md-block'>
//         <div className='row mt-3'>
//           {certificates.map((certificate, index) => (
//             <div className='col-4' key={index}>
//               <img className='Certificates shadow' src={certificate.src} alt={certificate.alt} onContextMenu={(e) => e.preventDefault()}/>
//             </div>
//           ))}
//         </div>
//         </div>
//       </div>
//       <div className='row d-sm-block d-md-none'>
//           {certificates.map((certificate, index) => (
//             <div className='col-md-4' key={index}>
//               <div className='p-2'>
//                 <img className='mobile_Certificates_img shadow' src={certificate.src} alt={certificate.alt} onContextMenu={(e) => e.preventDefault()}/>
//               </div>
//             </div>
//           ))}
//         </div>
//     </div>
//   )
// }
// export default Certificates


// slow animation 


// import React, { useState } from 'react'
// import cer1 from './image/cer1.jpeg'
// import cer2 from './image/cer2.jpg'
// import cer3 from './image/cer3.jpg'

// function Certificates() {
//   const certificates = [
//     { src: cer1, alt: 'Certificate 1' },
//     { src: cer2, alt: 'Certificate 2' },
//     { src: cer3, alt: 'Certificate 3' },
//   ]

//   const [isHovered, setIsHovered] = useState(false)

//   return (
//     <div>
//       <div className='container py-4'>
//         <div className='row'>
//           <div className='col-md-1'></div>
//           <div className='col-md-10'>
//             <div className='text-center Certificates_text'>
//               <h2 className='display-5 pb-2'>Certificates</h2>
//               <p>Prove Your Knowledge with Our Highly Esteemed Certifications, valued in All Professions.</p>
//             </div>
//           </div>
//           <div className='col-md-1'></div>
//         </div>

//         {/* Desktop Carousel */}
//         <div className='d-none d-md-block overflow-hidden'>
//           <div
//             className='scrolling-wrapper d-flex'
//             onMouseEnter={() => setIsHovered(true)}
//             onMouseLeave={() => setIsHovered(false)}
//             style={{
//               animationDuration: isHovered ? '60s' : '20s' // slow on hover
//             }}
//           >
//             {[...certificates, ...certificates].map((certificate, index) => (
//               <div className='px-2 flex-shrink-0 col-2' key={index}>
//                 <img
//                   className='Certificates shadow'
//                   src={certificate.src}
//                   alt={certificate.alt}
//                   onContextMenu={(e) => e.preventDefault()}
//                   style={{ objectFit: 'contain' }}
//                 />
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Mobile view */}
//       <div className='d-block d-md-none overflow-hidden'>
//         <div
//           className='scrolling-wrapper d-flex align-items-center'
//           onMouseEnter={() => setIsHovered(true)}
//           onMouseLeave={() => setIsHovered(false)}
//           style={{ animationDuration: isHovered ? '60s' : '20s' }}
//         >
//           {[...certificates, ...certificates].map((certificate, index) => (
//             <div
//               className='px-2 flex-shrink-0'
//               style={{ width: '150px', height: '120px' }}
//               key={index}
//             >
//               <img
//                 className='shadow rounded'
//                 src={certificate.src}
//                 alt={certificate.alt}
//                 onContextMenu={(e) => e.preventDefault()}
//                 style={{ width: '100%', height: '100%', objectFit: 'contain' }}
//               />
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* CSS Animation */}
//       <style>{`
//         .scrolling-wrapper {
//           display: flex;
//           width: max-content;
//           animation: scroll-left linear infinite;
//           animation-duration: 20s; /* default speed */
//         }
//         @keyframes scroll-left {
//           0% { transform: translateX(0); }
//           100% { transform: translateX(-50%); }
//         }
//       `}</style>
//     </div>
//   )
// }

// export default Certificates


import React from 'react'
import cer1 from './image/cer1.jpeg'
import cer2 from './image/cer2.jpg'
import cer3 from './image/cer3.jpg'

function Certificates() {
  const certificates = [
    { src: cer1, alt: 'Certificate 1' },
    { src: cer2, alt: 'Certificate 2' },
    { src: cer3, alt: 'Certificate 3' },
  ];

  return (
    <div>
      <div className='container py-4'>
        <div className='row'>
          <div className='col-md-1'></div>
          <div className='col-md-10'>
            <div className='text-center Certificates_text'>
              <h2 className='display-5 pb-2'>Certificates</h2>
              <p>Prove Your Knowledge with Our Highly Esteemed Certifications, valued in All Professions.</p>
            </div>
          </div>
          <div className='col-md-1'></div>
        </div>

        
        <div className='d-none d-md-block overflow-hidden'>
          <div className='scrolling-wrapper d-flex'>
            {[...certificates, ...certificates].map((certificate, index) => (
              <div className='px-2 flex-shrink-0 col-2' key={index}>
                <img
                  className='Certificates shadow'
                  src={certificate.src}
                  alt={certificate.alt}
                  onContextMenu={(e) => e.preventDefault()}
                   style={{  objectFit: 'contain' }}
                  
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile view */}
       <div className='d-block d-md-none overflow-hidden'>
          <div className='scrolling-wrapper d-flex align-items-center  '
          
          >
            {[...certificates, ...certificates].map((certificate, index) => (
              // <div
              //   className='px-2 flex-shrink-0'
              //   style={{ width: '150px', height: '120px' }}
              //   key={index}
              // >
              <div
                className='px-2 flex-shrink-0 '
                style={{ width: '185px', height: '125px' }}
                key={index}
              >
                <img
                  className='shadow rounded'
                  src={certificate.src}
                  alt={certificate.alt}
                  onContextMenu={(e) => e.preventDefault()}
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
              </div>
            ))}
          </div>
        </div>

      
      <style>{`
        .scrolling-wrapper {
          display: flex;
          width: max-content; /* container width = total cards width */
          animation: scroll-left 20s linear infinite;
        }
        @keyframes scroll-left {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); } /* scroll only original cards width */
        }
      `}</style>
    </div>
  )
}

export default Certificates


